interface Props {
  width?: string;
  height?: string;
}

const OtherIcon = ({ height, width }: Props) => {
  return (
    <svg
      width={width || "52"}
      height={height || "50"}
      viewBox="0 0 47 58"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.72169 57.2875C4.2536 57.2875 2.98048 56.7484 1.90235 55.6703C0.824222 54.5921 0.285156 53.319 0.285156 51.8509V5.74363C0.285156 4.22966 0.824222 2.93361 1.90235 1.85548C2.98048 0.777347 4.2536 0.238281 5.72169 0.238281H28.3624C29.0965 0.238281 29.8076 0.398854 30.4958 0.719999C31.1839 1.04114 31.7803 1.45405 32.285 1.9587L44.6032 14.2769C45.1079 14.7816 45.5208 15.378 45.8419 16.0662C46.1631 16.7543 46.3236 17.4654 46.3236 18.1995V51.8509C46.3236 53.319 45.7846 54.5921 44.7064 55.6703C43.6283 56.7484 42.3323 57.2875 40.8183 57.2875H5.72169ZM27.8119 15.7909V5.74363H5.72169V51.8509H40.8183V18.5436H30.5646C29.7847 18.5436 29.1309 18.2798 28.6033 17.7522C28.0757 17.2246 27.8119 16.5708 27.8119 15.7909Z" />
    </svg>
  );
};

export default OtherIcon;
